import { render, staticRenderFns } from "./MonkeyMode.vue?vue&type=template&id=fba46e3a&scoped=true"
import script from "./MonkeyMode.vue?vue&type=script&lang=js"
export * from "./MonkeyMode.vue?vue&type=script&lang=js"
import style0 from "./MonkeyMode.vue?vue&type=style&index=0&id=fba46e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba46e3a",
  null
  
)

export default component.exports